import(/* webpackMode: "eager", webpackExports: ["SplashScreen"] */ "/vercel/path0/libs/shared/core/ui/components/src/feedback/LoadingScreen/splash-screen.tsx");
